import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmbroideredMackyRoutingModule } from './embroidered-workwear-mackay.routing.module';
import { EmbroideredMackyComponent } from './embroidered-workwear-mackay.component';


@NgModule({
  declarations: [
    EmbroideredMackyComponent
  ],
  imports: [
    CommonModule,
    EmbroideredMackyRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EmbroideredMackyModule { }
